<template>
  <div class="ActivityItemTask__Component">
    <div class="ActivityItemTask__Component__Edit" v-if="isOpen">
      <div class="NewTask__Component__Attributes">
        <div class="Field ml-6">
          <FieldInlineText
            :hide-hover="true"
            label="שם עיריה"
            :clearable="false"
            :filterable="false"
            :readOnly="true"
            @onChange="onChange"
            v-model="model.Name"
          />
        </div>
        <div class="Field ml-6">
          <FieldInlineText
            :hide-hover="true"
            label="כתובת"
            :clearable="false"
            :filterable="false"
            @onChange="onChange"
            v-model="model.Address"
            :changeOnBlur="true"
          />
        </div>
        <div class="Field ml-6">
          <FieldInlineSelect
            :hide-hover="true"
            label='חתימת עו"ד'
            :clearable="false"
            :filterable="false"
            :options="[
              { Value: true, Text: 'צריך' },
              { Value: false, Text: 'לא צריך' },
            ]"
            @onChange="onChange"
            v-model="model.NeedLawyerSign"
          />
        </div>
        <div class="Field ml-6">
          <FieldInlineSelect
            :hide-hover="true"
            label=' חתימת עו"ד לעובד'
            :clearable="false"
            :filterable="false"
            :options="[
              { Value: true, Text: 'צריך' },
              { Value: false, Text: 'לא צריך' },
            ]"
            @onChange="onChange"
            v-model="model.NeedLawyerSignForDriver"
          />
        </div>
        <div class="Field ml-6">
          <FieldInlineText
            :hide-hover="true"
            label="אימייל להסבה"
            :clearable="false"
            :filterable="false"
            @onChange="onChange"
            v-model="model.TransferEmail"
            :changeOnBlur="true"
          />
        </div>
        <div class="Field ml-6">
          <FieldInlineText
            :hide-hover="true"
            label="אימייל להסבה תייר"
            :clearable="false"
            :filterable="false"
            @onChange="onChange"
            v-model="model.TouristTransferEmail"
            :changeOnBlur="true"
          />
        </div>
        <div class="Field ml-6">
          <FieldInlineText
            :hide-hover="true"
            label="לינק לתשלום"
            :clearable="false"
            :filterable="false"
            @onChange="onChange"
            v-model="model.PaymentUrl"
            :changeOnBlur="true"
          />
        </div>
        <div class="Field ml-6">
          <FieldInlineSelect
            :hide-hover="true"
            label="TransferBotId"
            :clearable="true"
            :filterable="false"
            :optionsAsync="getTransferBotIds"
            @onChange="onChange"
            v-model="model.TransferBotId"
          />
        </div>
        <div class="Field ml-6">
          <FieldInlineText
            :hide-hover="true"
            label="TransferBotAuthorityId"
            :clearable="false"
            :filterable="false"
            @onChange="onChange"
            v-model="model.TransferBotAuthorityId"
            :changeOnBlur="true"
          />
        </div>
        <div class="Field ml-6" :class="{ 'field-required': rePortIdError }">
          <FieldInlineText
            :hide-hover="true"
            label="מספר עירייה בריפורט (פרימיום ואונליין)"
            :clearable="false"
            :filterable="false"
            type="number"
            @onChange="onChange"
            v-model="model.RePortId"
            :changeOnBlur="true"
          />
          <p class="field-error" v-if="rePortIdError">{{ rePortIdError }}</p>
        </div>
        <div class="days-groups-wrapper">
        <div class="days-group">
          <div class="Field ml-6 field-with-tooltip">
            <b-tooltip
              label="מספר ימים מינימלי לאימות. אם תאריך האימות האחרון שהתקבל מהרשות עבר את הסף – הדוח יכול לצאת לשליחה גם לפני שהתקופה השנייה הסתיימה."
              position="is-top"
              multilined
              class="field-tooltip"
            >
              <b-icon icon="information" size="is-small" type="is-info" />
            </b-tooltip>
            <FieldInlineText
              :hide-hover="true"
              label="ימי השהית שליחה (תקופה ראשונה: מספר ימים מינימלי לאימות)"
              :clearable="false"
              :filterable="false"
              type="number"
              @onChange="onChange"
              v-model="model.SuspensionPeriodInDays"
              :changeOnBlur="true"
            />
          </div>
          <div class="Field ml-6 field-with-tooltip" :class="{ 'field-required': model.SecondSuspensionPeriodInDays === null || model.SecondSuspensionPeriodInDays === undefined || model.SecondSuspensionPeriodInDays === '' }">
            <b-tooltip
              label="דוח יוצא מהשהיה ונשלח רק אם עברו מספיק ימים מאז הוצאת הדוח."
              position="is-top"
              multilined
              class="field-tooltip"
            >
              <b-icon icon="information" size="is-small" type="is-info" />
            </b-tooltip>
            <FieldInlineText
              :hide-hover="true"
              label="ימי השהית שליחה (תקופה שנייה: זמן מקבלת הדוח )"
              :clearable="false"
              :filterable="false"
              type="number"
              @onChange="onChange"
              v-model="model.SecondSuspensionPeriodInDays"
              :changeOnBlur="true"
            />
          </div>
        </div>
        <div class="days-group">
          <div class="Field ml-6">
            <FieldInlineText
              :hide-hover="true"
              label="ימי המתנה לתשובה להסבה"
              :clearable="false"
              :filterable="false"
              @onChange="onChange"
              v-model="model.TransferClarificationDays"
              :changeOnBlur="true"
            />
          </div>
          <div class="Field ml-6">
            <FieldInlineText
              :hide-hover="true"
              label="ימי המתנה לתשובה להסבת תייר"
              :clearable="false"
              :filterable="false"
              @onChange="onChange"
              v-model="model.TouristTransferClarificationDays"
              :changeOnBlur="true"
            />
          </div>
        </div>
        </div>
        <div class="Field ml-6">
          <FieldInlineTextArea
            :hide-hover="true"
            label="הערות"
            @onChange="onChange"
            v-model="model.Notes"
            :changeOnBlur="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FieldInlineText from "@/components/Fields/FieldInlineText.vue";
import FieldInlineTextArea from "@/components/Fields/FieldInlineTextArea.vue";
import FieldInlineSelect from "@/components/Fields/FieldInlineSelect.vue";
import MunicipalitiesService from "@/services/MunicipalitiesService";

const CONFLICT_STATUS = 409;

export default {
  name: "ActivityItemTask",
  props: ["item", "isOpen", "entityType", "entityId"],
  components: {
    FieldInlineSelect,
    FieldInlineText,
    FieldInlineTextArea,
  },
  data() {
    return {
      isLoading: false,
      editTitleMode: false,
      editBodyMode: false,
      originalRePortId: null,
      rePortIdError: null,
      model: {
        Name: null,
        Address: null,
        NeedLawyerSign: null,
        NeedLawyerSignForDriver: null,
        TransferEmail: null,
        TouristTransferEmail: null,
        TransferClarificationDays: null,
        TouristTransferClarificationDays: null,
        PaymentUrl: null,
        TransferBotId: null,
        TransferBotAuthorityId: null,
        RePortId: null,
        SuspensionPeriodInDays: null,
        SecondSuspensionPeriodInDays: null,
        Notes: null,
      },
    };
  },
  created() {
    this.getFullItem();
  },
  methods: {
    getFullItem() {
      MunicipalitiesService.getMunicipality(this.item.Id).then((r) => {
        this.model = { ...r.data };
        this.originalRePortId = this.model.RePortId;
      });
    },
    getTransferBotIds() {
      return MunicipalitiesService.getTransferBotTypes;
    },
    onChange(isEmpty) {
      this.hasContent = !isEmpty;
      this.rePortIdError = null;
      if (this.model.SecondSuspensionPeriodInDays === null || this.model.SecondSuspensionPeriodInDays === undefined || this.model.SecondSuspensionPeriodInDays === '') {
        this.$buefy.toast.open({
          type: "is-danger",
          message: "שדה תקופה שנייה הוא שדה חובה!",
          duration: 4000,
        });
        return;
      }
      if (this.model.SuspensionPeriodInDays !== null && this.model.SuspensionPeriodInDays !== undefined &&
          Number(this.model.SuspensionPeriodInDays) > Number(this.model.SecondSuspensionPeriodInDays)) {
        this.$buefy.toast.open({
          type: "is-danger",
          message: "תקופה ראשונה חייבת להיות קטנה או שווה לתקופה השנייה!",
          duration: 4000,
        });
        return;
      }
      const pattern = /^[a-zA-Z0-9@.\-_!,]+$/;
      if ((pattern.test(this.model.TransferEmail) || this.model.TransferEmail === "") &&
          (pattern.test(this.model.TouristTransferEmail) || this.model.TouristTransferEmail === "")) {
        if (this.isRePortIdChanged()) {
          this.confirmRePortIdChange();
          return;
        }
        this.update();
      } else {
        this.$buefy.toast.open({
          type: "is-danger",
          message: "יש להזין תווים חוקיים באימייל להסבה!",
          duration: 4000,
        });
      }
    },
    isRePortIdChanged() {
      return this.normalizeRePortId(this.model.RePortId) !== this.normalizeRePortId(this.originalRePortId);
    },
    normalizeRePortId(value) {
      return value === null || value === undefined || value === "" ? null : Number(value);
    },
    confirmRePortIdChange() {
      const current = this.normalizeRePortId(this.originalRePortId);
      const updated = this.normalizeRePortId(this.model.RePortId);
      this.$buefy.dialog.confirm({
        title: "שינוי מספר עירייה בריפורט (פרימיום ואונליין)",
        message: `האם לשנות את מספר העירייה בריפורט מ-${current === null ? "(ריק)" : current} ל-${updated === null ? "(ריק)" : updated}? שינוי זה משפיע על שיוך הדוחות המתקבלים מריפורט.`,
        confirmText: "שנה",
        cancelText: "בטל",
        type: "is-warning",
        hasIcon: true,
        onConfirm: () => this.update(),
        onCancel: () => {
          this.model.RePortId = this.originalRePortId;
        },
      });
    },
    update() {
      this.isLoading = true;
      MunicipalitiesService.updateMunicipality(this.item.Id, this.model)
        .then(() => {
          this.originalRePortId = this.model.RePortId;
          this.$buefy.toast.open({
            type: "is-success",
            message: "ההערה נשמרה!",
            duration: 4000,
          });
        })
        .catch((err) => {
          this.showUpdateError(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showUpdateError(err) {
      const conflict = err.response?.status === CONFLICT_STATUS ? err.response.data : null;
      let message = "קרתה תקלה, לא היה ניתן לשמור את השינויים!";

      if (conflict?.MunicipalityName) {
        message = `מספר עירייה בריפורט ${conflict.RePortId} כבר משויך לעירייה ${conflict.MunicipalityName} (מזהה ${conflict.MunicipalityId}). יש להזין מספר אחר.`;
        this.rePortIdError = message;
      }

      this.$buefy.toast.open({
        type: "is-danger",
        message,
        duration: 6000,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.ActivityItemTask__Component__Edit {
  padding: 15px 0;
  border-top: 1px solid #d8d8d8;
  overflow: visible;
}
.Activity__Item__Box__Content__Text__Title {
  display: flex;
  align-items: start;
  padding-bottom: 15px;

  ::v-deep {
    .NewTask__Component__Editor__Actions {
      display: none;
    }
    .ProseMirror {
      min-height: unset !important;
      padding: 2px 5px;
    }
  }

  button {
    border: none;
    background-color: transparent;
    cursor: pointer;
  }

  .icon {
    color: silver;
  }
  &.complete {
    .icon {
      color: #00bda5;
    }
    span {
      text-decoration: line-through;
    }
  }
}
.NewTask__Component__Reminder {
  padding: 0 20px;

  .NewTask__Component__Reminder__Fields {
    display: flex;
    padding-bottom: 5px;

    & > div {
      width: 140px;
      display: flex;
      flex-grow: 1;
    }
  }
}
.days-groups-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 4px 0;
}
.days-group {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  min-width: 200px;
  border: 1px solid #d0e4f0;
  border-radius: 6px;
  padding: 2px 4px;
}
.field-with-tooltip {
  display: flex;
  align-items: center;
  gap: 6px;

  ::v-deep .InlineField__Component {
    flex: 1;
  }

  .field-tooltip {
    flex-shrink: 0;
    margin-top: 16px;
  }

  ::v-deep .tooltip-content {
    max-width: 220px;
    white-space: normal;
    text-align: right;
  }
}
.field-required {
  ::v-deep input {
    border-bottom: 1px solid #ff3860 !important;
  }
}
.field-error {
  color: #ff3860;
  font-size: 12px;
  direction: rtl;
  text-align: right;
  max-width: 200px;
}
.NewTask__Component__Attributes {
  margin: 0 20px;
  padding: 0px 0;
  display: flex;
  border-bottom: 1px solid #d8d8d8;

  ::v-deep .vs__open-indicator {
    fill: #0091ae;
    transform: scale(0.6);
  }
  ::v-deep .vs__selected {
    color: #0091ae;
    font-weight: bold;
  }
  ::v-deep .vs__dropdown-toggle {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
      color: #0091ae;
      cursor: pointer;
    }
  }
}
.Activity__Item__Box__Content__Text__Editor {
  padding-right: 15px;
  margin: 10px 0;
}
.Activity__Item__Box__Content__Text__Editor__Actions {
  margin-bottom: 20px;

  button {
    border: none;
    background-color: transparent;
    padding: 5px 10px;
    cursor: pointer;
    line-height: normal;
    height: unset;
    font-size: 15px;

    &:active {
      transform: scale(0.97);
    }

    &.Save {
      background-color: #486480;
      color: white;
      border-radius: 3px;
      transition: transform 0.1s cubic-bezier(0.075, 0.82, 0.165, 1);
      &:hover {
        background-color: #597794;
      }
    }
    &.Cancel {
      background-color: #d0d0d0;
      color: black;
      border-radius: 3px;
      margin-right: 5px;

      &:hover {
        background-color: #e4e4e4;
      }
    }
  }
}
.Activity__Item__Box__Content__Text__Editor {
  direction: rtl;
  padding-right: 14px;
  font-size: 14px;
  position: relative;
  color: black;
  padding: 10px 10px 30px 10px;
  border: 1px solid transparent;
  border-radius: 3px;
  max-height: 55px;
  overflow: hidden;

  &.--Title {
    padding: 0;
    margin: 0;
  }

  &:not(.open)::after {
    background-image: linear-gradient(#04040400 50%, #ffffff);
    height: 55px;
    opacity: 1;
    pointer-events: none;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    content: "";
  }
  &.open {
    max-height: unset;
    &:hover {
      background-color: #e5f5f8;
      border: 1px solid #addbff;
    }
  }
}
</style>

<style lang="scss">
.field-tooltip .tooltip-content {
  max-width: 220px;
  white-space: normal;
  text-align: right;
  right: 0 !important;
  left: auto !important;
  transform: translateX(0) !important;
}
</style>
